import api from "../../api/apiInterceptor";

export function fetchInstallationsWithoutPaggination(){
    return api.get("/api/installations/all")
}

export function fetchAllInstallations(page,pageSize,searchVal){
    return api.get(`/api/installations?page=${page}&size=${pageSize}&search=${searchVal}`)
}

export function createInstallations(data){
    return api.post("/api/installations",data)
}

export function deleteInstallations(id){
    return api.delete(`/api/installations/${id}`)
}

export function updateInstallations(data,itemId){
    return api.put(`/api/installations/${itemId}`,data)
}

export function checkUserStatus(){
    return api.get("/user")
}